'use client';

import { createContext, useContext } from 'react';
import type { SidePref } from './useRushMidMatch';

export interface RushMidPartyMemberView {
  userId: string;
  name: string;
  ready: boolean;
  canAfford: boolean;
}

export interface RushMidPartyValue {
  code: string;
  isLeader: boolean;
  leaderUserId: string;
  youUserId: string;
  members: RushMidPartyMemberView[];
  mode: number;
  ticket: number;
  side: SidePref;
  matchMode?: 'ranked' | 'bots';
  allowedModes: number[];
  onConfig: (mode: number, ticket: number, side: SidePref, matchMode: 'ranked' | 'bots') => void;
  onReady: (ready: boolean) => void;
  onLeave: () => void;
  onKick: (userId: string) => void;
  onShare: () => void;
  sharing?: boolean;
}

const RushMidPartyContext = createContext<RushMidPartyValue | null>(null);

export const RushMidPartyProvider = RushMidPartyContext.Provider;

export const useRushMidParty = (): RushMidPartyValue | null => useContext(RushMidPartyContext);
